<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="3" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add Coin Seller OR Merchant
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.unique_id"
                outlined
                type="number"
                label="Enter Unique ID *"
                prepend-inner-icon="mdi-identifier"
                :rules="[rules.required]"
                hint="Enter the Unique ID of the user"
                :error-messages="validationErrors.unique_id"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.whatsapp_no"
                outlined
                type="tel"
                maxlength="10"
                label="WhatsApp Number *"
                prepend-inner-icon="mdi-whatsapp"
                :rules="[rules.required, rules.phone]"
                hint="Enter WhatsApp Number of the user"
                :error-messages="validationErrors.whatsapp_no"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save BD Member
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "UserPositionCreatePage",
  data() {
    return {
      form: {
        unique_id: null,
        whatsapp_no: null,
      },
      isLoading: false,
      errors: {},
      rules: {
        required: (value) => !!value || "Required.",
        phone: (value) => {
          const pattern = /^[0-9]{10}$/;
          return (
            pattern.test(value) || "Invalid phone number (10 digits required)"
          );
        },
      },
    };
  },
  mounted() {
    // this.getUsers();
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.errors = {};

        // ✅ API call to BD Members endpoint
        let response = await axios.post("/users/update_flag", this.form);

        // ✅ Response handling
        this.bd_member = response.data.data;
        console.log("BD Member created:", this.bd_member);
        console.log("Form data:", this.form);

        // ✅ Save timestamp log
        await this.saveUserTimestamp(null, this.form);

        // ✅ Success message
        alert(
          response.data.message ||
            "BD Member created successfully! User is_bd flag set to 1."
        );

        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        this.isLoading = false;

        // ✅ Always safe logging
        console.log("error", e);

        if (e.response && e.response.data) {
          // Laravel validation error structure check
          if (e.response.data.errors) {
            this.errors = e.response.data.errors;
            let msg = e.response.data.message || "Validation error occurred.";
            alert(msg);
          } else if (e.response.data.message) {
            // General error (like user already BD member)
            alert(e.response.data.message);
          } else {
            alert("Unexpected server error.");
          }
        } else {
          // ❌ No response (network issue)
          alert(
            "Network error: Cannot reach server. Please check if backend is running."
          );
        }
      }
    },

    async saveUserTimestamp(oldData, newData) {
      try {
        let form = {
          from_path: `/bd-members/create`,
          from_name: "BDMemberCreatePage",
          user_id: this.$store.state.user?.id,
          old_json: oldData ? JSON.stringify(oldData) : null,
          new_json: JSON.stringify(newData),
        };
        await axios.post(`/user_timestamps`, form);
      } catch (error) {
        console.log("timestamp error", error);
      }
    },
  },
};
</script>
